// Lucide Icons helper
// Usage: icon('map-pin', 'w-5 h-5 text-amber-400')
// Brand icons: brandIcon('facebook', 'w-5 h-5')

import {
  Accessibility,
  ArrowDown,
  AtSign,
  ArrowLeft,
  ArrowRight,
  ArrowRightLeft,
  ArrowUp,
  Award,
  Ban,
  Bath,
  Bed,
  Bell,
  BellOff,
  Bike,
  Binoculars,
  Book,
  BookOpen,
  Bookmark,
  Brain,
  Briefcase,
  Bug,
  Cake,
  Calendar,
  CalendarDays,
  CalendarPlus,
  Camera,
  Car,
  CarFront,
  ChartBar,
  ChartLine,
  Check,
  CheckCheck,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleHelp,
  CirclePlus,
  CircleStop,
  CircleX,
  ClipboardCheck,
  ClipboardList,
  Clock,
  Cloud,
  CloudUpload,
  Coffee,
  Coins,
  Columns2,
  Compass,
  Cookie,
  Copy,
  CornerDownLeft,
  CornerDownRight,
  CreditCard,
  Crosshair,
  Crown,
  Database,
  Download,
  Droplets,
  Expand,
  ExternalLink,
  Eye,
  Flower2,
  Footprints,
  EyeOff,
  FileText,
  Flag,
  FlagTriangleRight,
  Flame,
  FlipHorizontal,
  Forward,
  Frown,
  Fuel,
  Funnel,
  Gamepad,
  Gem,
  Gift,
  GitFork,
  GitMerge,
  Globe,
  GraduationCap,
  Grid2x2,
  Hand,
  HandCoins,
  HandHeart,
  HandMetal,
  Handshake,
  Heart,
  History,
  Home,
  Hotel,
  IdCard,
  Image,
  Inbox,
  Info,
  Key,
  Languages,
  Laptop,
  Leaf,
  Lightbulb,
  Link,
  List,
  LoaderCircle,
  Locate,
  Lock,
  LockOpen,
  LogIn,
  LogOut,
  Mail,
  Map,
  MapPin,
  MapPinOff,
  MapPinned,
  Medal,
  Megaphone,
  Meh,
  MessageCircle,
  MessageCircleMore,
  MessageSquare,
  MessageSquarePlus,
  MessagesSquare,
  Mic,
  Milestone,
  Minimize,
  Minus,
  Moon,
  Monitor,
  Mountain,
  Music,
  Navigation,
  Newspaper,
  Notebook,
  Orbit,
  Palette,
  PartyPopper,
  PawPrint,
  Pencil,
  PenTool,
  Percent,
  Phone,
  PhoneCall,
  PhoneIncoming,
  Pizza,
  Play,
  PlayCircle,
  Plug,
  Plus,
  Pointer,
  Radio,
  Radar,
  RadioTower,
  RefreshCw,
  Reply,
  Rainbow,
  Rocket,
  RotateCw,
  Route,
  Ruler,
  Save,
  Scale,
  Scroll,
  ScrollText,
  ScanEye,
  Search,
  Send,
  Settings,
  Share,
  Share2,
  Shield,
  ShieldAlert,
  ShieldCheck,
  Shirt,
  ShoppingBasket,
  ShoppingCart,
  ShowerHead,
  Shrink,
  SignpostBig,
  Signpost,
  Siren,
  Skull,
  SlidersHorizontal,
  Smartphone,
  Smile,
  Sofa,
  Sparkles,
  Sprout,
  Square,
  SquareParking,
  Star,
  StarHalf,
  Store,
  Sun,
  SunMoon,
  Tag,
  Target,
  ThumbsDown,
  ThumbsUp,
  Ticket,
  Trash,
  Trash2,
  TriangleAlert,
  Trophy,
  Umbrella,
  Undo,
  Upload,
  User,
  UserCheck,
  UserCog,
  UserMinus,
  UserPlus,
  UserX,
  Users,
  Utensils,
  Video,
  Volume2,
  WandSparkles,
  Waves,
  Wifi,
  WifiOff,
  Wine,
  X,
  Zap,
} from 'lucide'

// ── Lucide icon name → component (canonical names) ───────────────────
const ICON_MAP = {
  'accessibility': Accessibility,
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-right-left': ArrowRightLeft,
  'arrow-up': ArrowUp,
  'at-sign': AtSign,
  'award': Award,
  'backpack': Briefcase,
  'ban': Ban,
  'bath': Bath,
  'bed': Bed,
  'bell': Bell,
  'bell-off': BellOff,
  'bike': Bike,
  'binoculars': Binoculars,
  'book': Book,
  'book-open': BookOpen,
  'bookmark': Bookmark,
  'brain': Brain,
  'briefcase': Briefcase,
  'bug': Bug,
  'cake': Cake,
  'calendar': Calendar,
  'calendar-days': CalendarDays,
  'calendar-plus': CalendarPlus,
  'camera': Camera,
  'car': Car,
  'car-front': CarFront,
  'chart-bar': ChartBar,
  'chart-line': ChartLine,
  'check': Check,
  'check-check': CheckCheck,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'circle': Circle,
  'circle-alert': CircleAlert,
  'circle-check': CircleCheck,
  'circle-help': CircleHelp,
  'circle-plus': CirclePlus,
  'circle-stop': CircleStop,
  'circle-x': CircleX,
  'clipboard-check': ClipboardCheck,
  'clipboard-list': ClipboardList,
  'clock': Clock,
  'cloud': Cloud,
  'cloud-upload': CloudUpload,
  'clover': Leaf,
  'coffee': Coffee,
  'coins': Coins,
  'columns-2': Columns2,
  'compass': Compass,
  'cookie': Cookie,
  'copy': Copy,
  'credit-card': CreditCard,
  'corner-down-left': CornerDownLeft,
  'corner-down-right': CornerDownRight,
  'crosshair': Crosshair,
  'crown': Crown,
  'database': Database,
  'download': Download,
  'droplets': Droplets,
  'expand': Expand,
  'external-link': ExternalLink,
  'eye': Eye,
  'eye-off': EyeOff,
  'file-text': FileText,
  'flag': Flag,
  'flower': Flower2,
  'flower-2': Flower2,
  'footprints': Footprints,
  'flag-triangle-right': FlagTriangleRight,
  'flame': Flame,
  'flip-horizontal': FlipHorizontal,
  'forward': Forward,
  'frown': Frown,
  'fuel': Fuel,
  'funnel': Funnel,
  'gamepad': Gamepad,
  'gem': Gem,
  'gift': Gift,
  'git-fork': GitFork,
  'git-merge': GitMerge,
  'github': null, // served via BRANDS fallback (brand icon removed from lucide 1.x)
  'globe': Globe,
  'graduation-cap': GraduationCap,
  'grid-2x2': Grid2x2,
  'hand': Hand,
  'hand-coins': HandCoins,
  'hand-heart': HandHeart,
  'hand-metal': HandMetal,
  'handshake': Handshake,
  'heart': Heart,
  'history': History,
  'home': Home,
  'hotel': Hotel,
  'id-card': IdCard,
  'image': Image,
  'inbox': Inbox,
  'info': Info,
  'key': Key,
  'language': Languages,
  'languages': Languages,
  'laptop': Laptop,
  'leaf': Leaf,
  'lightbulb': Lightbulb,
  'link': Link,
  'list': List,
  'loader-circle': LoaderCircle,
  'locate': Locate,
  'lock': Lock,
  'lock-open': LockOpen,
  'log-in': LogIn,
  'log-out': LogOut,
  'mail': Mail,
  'map': Map,
  'map-pin': MapPin,
  'map-pin-off': MapPinOff,
  'map-pinned': MapPinned,
  'medal': Medal,
  'megaphone': Megaphone,
  'meh': Meh,
  'message-circle': MessageCircle,
  'message-circle-more': MessageCircleMore,
  'message-square': MessageSquare,
  'message-square-plus': MessageSquarePlus,
  'messages-square': MessagesSquare,
  'mic': Mic,
  'milestone': Milestone,
  'minimize': Minimize,
  'minus': Minus,
  'monitor': Monitor,
  'moon': Moon,
  'mountain': Mountain,
  'music': Music,
  'navigation': Navigation,
  'newspaper': Newspaper,
  'notebook': Notebook,
  'orbit': Orbit,
  'palette': Palette,
  'parking-meter': SquareParking,
  'party-popper': PartyPopper,
  'paw-print': PawPrint,
  'pen-tool': PenTool,
  'pencil': Pencil,
  'percent': Percent,
  'phone': Phone,
  'phone-call': PhoneCall,
  'phone-incoming': PhoneIncoming,
  'pizza': Pizza,
  'play': Play,
  'play-circle': PlayCircle,
  'plug': Plug,
  'plus': Plus,
  'pointer': Pointer,
  'radar': Radar,
  'radio': Radio,
  'radio-tower': RadioTower,
  'rainbow': Rainbow,
  'refresh-cw': RefreshCw,
  'reply': Reply,
  'rocket': Rocket,
  'rotate-cw': RotateCw,
  'route': Route,
  'ruler': Ruler,
  'save': Save,
  'scale': Scale,
  'scroll': Scroll,
  'scroll-text': ScrollText,
  'scan-eye': ScanEye,
  'search': Search,
  'send': Send,
  'settings': Settings,
  'share': Share,
  'share-2': Share2,
  'shield': Shield,
  'shield-alert': ShieldAlert,
  'shield-check': ShieldCheck,
  'shirt': Shirt,
  'shopping-basket': ShoppingBasket,
  'shopping-cart': ShoppingCart,
  'shower-head': ShowerHead,
  'shrink': Shrink,
  'sign-post': SignpostBig,
  'signpost': Signpost,
  'siren': Siren,
  'skull': Skull,
  'sliders-horizontal': SlidersHorizontal,
  'smartphone': Smartphone,
  'smile': Smile,
  'sofa': Sofa,
  'sparkles': Sparkles,
  'sprout': Sprout,
  'square': Square,
  'square-parking': SquareParking,
  'star': Star,
  'star-half': StarHalf,
  'store': Store,
  'sun': Sun,
  'sun-moon': SunMoon,
  'tag': Tag,
  'salad': Leaf,
  'target': Target,
  'theater': Sparkles,
  'thumbs-down': ThumbsDown,
  'thumbs-up': ThumbsUp,
  'ticket': Ticket,
  'trash': Trash,
  'trash-2': Trash2,
  'triangle-alert': TriangleAlert,
  'trophy': Trophy,
  'umbrella': Umbrella,
  'undo': Undo,
  'unlock': LockOpen,
  'upload': Upload,
  'user': User,
  'user-check': UserCheck,
  'user-cog': UserCog,
  'user-minus': UserMinus,
  'user-plus': UserPlus,
  'user-x': UserX,
  'users': Users,
  'utensils': Utensils,
  'video': Video,
  'volume-2': Volume2,
  'wand-sparkles': WandSparkles,
  'waves': Waves,
  'wifi': Wifi,
  'wifi-off': WifiOff,
  'wine': Wine,
  'x': X,
  'zap': Zap,
}

// ── Legacy FA name aliases (for dynamic/computed names) ──────────────
const FA_ALIASES = {
  'ad': 'megaphone',
  'alert-triangle': 'triangle-alert',
  'angry': 'frown',
  'balance-scale': 'scale',
  'bell-slash': 'bell-off',
  'bicycle': 'bike',
  'birthday-cake': 'cake',
  'book-atlas': 'book-open',
  'broadcast-tower': 'radio-tower',
  'bullseye': 'crosshair',
  'calendar-alt': 'calendar-days',
  'car-side': 'car-front',
  'check-circle': 'circle-check',
  'check-double': 'check-check',
  'circle-notch': 'loader-circle',
  'clone': 'copy',
  'cloud-upload-alt': 'cloud-upload',
  'code-fork': 'git-fork',
  'code-merge': 'git-merge',
  'cog': 'settings',
  'cogs': 'settings',
  'columns': 'columns-2',
  'comment': 'message-circle',
  'comment-dots': 'message-circle-more',
  'comments': 'messages-square',
  'compress': 'shrink',
  'compress-alt': 'minimize',
  'cookie-bite': 'cookie',
  'couch': 'sofa',
  'crosshairs': 'crosshair',
  'edit': 'pencil',
  'edit-3': 'pencil',
  'notebook-pen': 'pencil',
  'envelope': 'mail',
  'exchange-alt': 'arrow-right-left',
  'exclamation-circle': 'circle-alert',
  'exclamation-triangle': 'triangle-alert',
  'external-link-alt': 'external-link',
  'eye-slash': 'eye-off',
  'file-alt': 'file-text',
  'filter': 'funnel',
  'fire': 'flame',
  'fist-raised': 'hand-metal',
  'flag-checkered': 'flag-triangle-right',
  'gas-pump': 'fuel',
  'gavel': 'scale',
  'glass-martini-alt': 'wine',
  'globe-americas': 'globe',
  'hand-holding-heart': 'hand-heart',
  'hand-holding-usd': 'hand-coins',
  'hand-pointer': 'pointer',
  'help-circle': 'circle-help',
  'info-circle': 'info',
  'location-arrow': 'navigation',
  'location-crosshairs': 'locate',
  'location-dot': 'map-pin',
  'magic': 'wand-sparkles',
  'map-location-dot': 'map-pinned',
  'map-marked-alt': 'map-pinned',
  'map-marker-alt': 'map-pin',
  'map-signs': 'signpost',
  'mobile-alt': 'smartphone',
  'mug-hot': 'coffee',
  'mug-saucer': 'coffee',
  'paper-plane': 'send',
  'parking': 'square-parking',
  'paw': 'paw-print',
  'person': 'user',
  'phone-alt': 'phone',
  'pizza-slice': 'pizza',
  'plus-circle': 'circle-plus',
  'question': 'info',
  'question-circle': 'info',
  'restroom': 'bath',
  'road': 'milestone',
  'rotate-right': 'rotate-cw',
  'search-location': 'search',
  'seedling': 'sprout',
  'share-alt': 'share-2',
  'shield-alt': 'shield',
  'shower': 'shower-head',
  'sign-in-alt': 'log-in',
  'sign-out-alt': 'log-out',
  'skull-crossbones': 'skull',
  'sliders-h': 'sliders-horizontal',
  'sms': 'message-square',
  'spinner': 'loader-circle',
  'star-half-alt': 'star-half',
  'stop': 'circle-stop',
  'street-view': 'binoculars',
  'sync-alt': 'refresh-cw',
  'th': 'grid-2x2',
  'ticket-alt': 'ticket',
  'times': 'x',
  'times-circle': 'circle-x',
  'trash-alt': 'trash',
  'tshirt': 'shirt',
  'turn-left': 'corner-down-left',
  'turn-right': 'corner-down-right',
  'universal-access': 'accessibility',
  'user-clock': 'user-cog',
  'user-friends': 'users',
  'user-secret': 'scan-eye',
  'user-slash': 'user-x',
  'user-times': 'user-x',
  'users-cog': 'user-cog',
  'users-slash': 'users',
  'wand-magic-sparkles': 'wand-sparkles',
  'water': 'droplets',
  'wifi-slash': 'wifi-off',
  'paypal': 'credit-card',
}

// ── Brand SVGs (inline, ~200-400 bytes each) ─────────────────────────
const BRANDS = {
  facebook: '<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>',
  apple: '<path d="M12 2C9.5 2 8.4 3.6 8 4.5c-.4-.3-1.2-.7-2.2-.5C4 4.3 3 5.8 3 7.5c0 2.5 1.5 5.5 3 7.5 1 1.3 2 2.5 3 2.5.8 0 1.3-.4 2-.4s1.2.4 2 .4c1 0 2-1.2 3-2.5 1.5-2 3-5 3-7.5 0-1.7-1-3.2-2.8-3.5-1-.2-1.8.2-2.2.5-.4-.9-1.5-2.5-4-2.5z"/><path d="M12 2c0 1.5-.5 3-2 4"/>',
  google: '<path d="M21.8 10.4h-9.5v3.5h5.5c-.5 2.5-2.7 4.1-5.5 4.1-3.3 0-6-2.7-6-6s2.7-6 6-6c1.5 0 2.8.5 3.9 1.4l2.6-2.6C17.1 3.2 14.7 2 12 2 6.5 2 2 6.5 2 12s4.5 10 10 10c5 0 9.5-3.5 10-8.5.1-.7 0-1.4 0-2.1-.1-.3-.1-.7-.2-1z"/>',
  SMS: '<path d="M17.5 14.4c-.3-.15-1.7-.85-2-1-.3-.1-.5-.15-.7.15-.2.3-.75.95-.9 1.15-.2.2-.35.2-.65.05-1.8-.9-3-1.6-4.2-3.6-.3-.55.3-.5.9-1.7.1-.2.05-.35-.025-.5-.075-.15-.7-1.7-.95-2.3-.25-.6-.5-.55-.7-.55h-.6c-.2 0-.5.075-.8.375-.25.3-1 1-1 2.4s1.025 2.8 1.175 3c.15.2 2 3.1 4.9 4.35 1.8.8 2.5.85 3.4.7.55-.1 1.7-.7 1.95-1.35.25-.7.25-1.25.175-1.375-.075-.125-.275-.2-.575-.35zM12.05 21.8c-1.75 0-3.45-.45-4.95-1.35l-.35-.2-3.7 1 1-3.6-.25-.4A9.8 9.8 0 0 1 2.2 12c0-5.4 4.4-9.8 9.85-9.8 2.6 0 5.1 1 6.95 2.9a9.7 9.7 0 0 1 2.9 6.9c0 5.45-4.45 9.8-9.85 9.8zM20.5 3.5A11.8 11.8 0 0 0 12.05 0C5.5 0 .15 5.35.15 11.95c0 2.1.55 4.15 1.6 5.95L0 24l6.3-1.65c1.75.95 3.7 1.45 5.75 1.45C18.6 23.8 24 18.5 24 11.9c0-3.15-1.25-6.15-3.5-8.4z"/>',
  telegram: '<path d="M22 2L11 13"/><path d="M22 2L15 22l-4-9-9-4z"/>',
  twitter: '<path d="M4 4l7.1 8.5L4 20h1.7l6.2-6.5L17 20h5l-7.5-9L21 4h-1.7l-5.7 6L9 4z"/>',
  instagram: '<rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="5"/><circle cx="17.5" cy="6.5" r="1.5"/>',
  github: '<path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.4 5.4 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65S8.93 17.38 9 18v4"/><path d="M9 18c-4.51 2-5-2-7-2"/>',
  waze: '<circle cx="12" cy="12" r="10"/><circle cx="9" cy="10" r="1.5" fill="currentColor"/><circle cx="15" cy="10" r="1.5" fill="currentColor"/><path d="M8 15c1.3 1.3 2.7 2 4 2s2.7-.7 4-2"/>',
  paypal: '<path d="M7.1 19.5H4.3c-.4 0-.7-.3-.6-.7L6.5 3.3c.1-.3.3-.5.6-.5h5.5c1.8 0 3.2.5 4 1.4.7.8 1 1.9.7 3.2-.6 3-3 4.6-6 4.6H9.4c-.4 0-.7.3-.8.7l-.8 4.8c0 .3-.3.5-.6.5z"/><path d="M19.5 8.3c-.6 3-3 4.6-6 4.6h-1.9c-.4 0-.7.3-.8.7l-1 6.2c0 .3.2.5.5.5h2.8c.4 0 .6-.3.7-.6l.6-3.5c.1-.4.4-.7.8-.7h.5c2.7 0 4.8-1.5 5.3-4.1.3-1.3.1-2.3-.5-3.1z"/>',
}

// ── SVG string builder (no DOM needed) ───────────────────────────────
function buildSvg(iconNode, cls, size) {
  const children = iconNode.map(([tag, attrs]) => {
    const a = Object.entries(attrs).map(([k, v]) => `${k}="${v}"`).join(' ')
    return `<${tag} ${a}/>`
  }).join('')

  return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide ${cls}" aria-hidden="true">${children}</svg>`
}

// ── Main helper ──────────────────────────────────────────────────────
export function icon(name, cls = '', size = 20) {
  // Handle combined names like 'arrow-up rotate-45'
  const parts = name.replace(/^fa-/, '').split(' ')
  let key = parts[0]
  const extraCls = parts.slice(1).map(p => p.replace(/^fa-/, '')).join(' ')
  const finalCls = [cls, extraCls].filter(Boolean).join(' ')

  // Resolve legacy FA aliases to Lucide names
  if (FA_ALIASES[key]) key = FA_ALIASES[key]

  const iconNode = ICON_MAP[key]
  if (!iconNode) {
    if (BRANDS[key]) return brandIcon(key, finalCls, size)
    return ''
  }
  return buildSvg(iconNode, finalCls, size)
}

// ── Brand icon helper ────────────────────────────────────────────────
export function brandIcon(name, cls = '', size = 20) {
  const paths = BRANDS[name]
  if (!paths) return ''
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="currentColor" stroke="none" class="lucide-brand ${cls}" aria-hidden="true">${paths}</svg>`
}

// ── Spinning icon ────────────────────────────────────────────────────
export function spinnerIcon(cls = '', size = 20) {
  return icon('loader-circle', `animate-spin ${cls}`, size)
}

// ── Avatar renderer ─────────────────────────────────────────────────
// Shows emoji avatar if set, otherwise SpotHitch logo
export function renderAvatar(avatar, cls = 'w-6 h-6') {
  if (!avatar || avatar === '👍') {
    return icon('thumbs-up', cls + ' text-amber-400')
  }
  // If avatar is a Lucide icon name (ASCII letters/hyphens only), render as icon
  if (/^[a-z][a-z0-9-]*$/.test(avatar) && ICON_MAP[avatar]) {
    return icon(avatar, cls + ' text-amber-400')
  }
  // Legacy emoji avatars from existing users
  return `<span class="inline-flex items-center justify-center">${avatar}</span>`
}

export const DEFAULT_AVATAR_ICON = 'thumbs-up'
